import React from 'react';
import './tailSpinLoader.css';
import { t } from 'i18next';

const TailSpinLoader = () => {
    return (
        <div className="loader-container">
            <div className="offolio-logo-spinner"></div>
            <div className="loading-text">
                <div className="loading-title">{t('global.loading...')}</div>
            </div>
        </div>
    );
};

export default TailSpinLoader;
